export const CITIZENSHIP_FAQS = [
  {
    id: "citizen-pr-automatic",
    question: "영주권을 받으면 시민권이 자동으로 생기나요?",
    answer: "아닙니다. 올바른 pathway로 신청하고 residence, identity, character와 해당 test·pledge requirements를 충족해야 합니다.",
    sourceIds: ["citizenship-source-conferral"],
  },
  {
    id: "citizen-residence",
    question: "일반 residence requirement는 무엇인가요?",
    answer: "현재 calculator는 신청 직전 4년 lawful residence, 마지막 12개월 permanent residence·해당 SCV와 해외 체류 한도를 안내합니다. exemptions와 실제 Department assessment를 함께 확인하세요.",
    sourceIds: ["citizenship-source-residence"],
  },
  {
    id: "citizen-calculator",
    question: "Residence Calculator가 eligible이라고 하면 확정인가요?",
    answer: "아닙니다. calculator는 guide only이며 실제 평가는 lodging 당시 Department records와 application evidence를 기준으로 합니다.",
    sourceIds: ["citizenship-source-residence"],
  },
  {
    id: "citizen-travel-record",
    question: "출입국 날짜를 정확히 모르겠습니다.",
    answer: "passport 기록을 정리하고 movement records를 요청해 Australia 출입국 dates와 visa information을 대조하세요.",
    sourceIds: ["citizenship-source-movement"],
  },
  {
    id: "citizen-travel-after",
    question: "신청 후 해외여행해도 되나요?",
    answer: "current visa·passport validity와 application update 의무를 확인하고 연락·appointment를 놓치지 않도록 travel details를 관리하세요.",
    sourceIds: ["citizenship-source-conferral", "citizenship-source-processing"],
  },
  {
    id: "citizen-test-who",
    question: "모든 신청자가 test를 보나요?",
    answer: "아닙니다. 대부분의 conferral applicant 중 해당 연령대는 test를 보지만 일부는 interview만 진행합니다. appointment notice를 확인하세요.",
    sourceIds: ["citizenship-source-test"],
  },
  {
    id: "citizen-test-study",
    question: "시험은 무엇으로 공부해야 하나요?",
    answer: "Home Affairs는 Australian Citizenship: Our Common Bond가 필요한 공식 준비자료라고 안내합니다.",
    sourceIds: ["citizenship-source-common-bond"],
  },
  {
    id: "citizen-processing",
    question: "processing time 안에 반드시 결정되나요?",
    answer: "아닙니다. published time은 monthly guide이며 case circumstances와 document completeness에 따라 달라질 수 있습니다.",
    sourceIds: ["citizenship-source-processing"],
  },
  {
    id: "citizen-approved",
    question: "approval letter를 받으면 바로 시민인가요?",
    answer: "pledge가 필요한 대부분의 사람은 ceremony에서 pledge를 해야 최종 citizenship을 취득합니다.",
    sourceIds: ["citizenship-source-ceremony"],
  },
  {
    id: "citizen-dual",
    question: "기존 국적을 반드시 포기해야 하나요?",
    answer: "Australia 절차만으로 단정하지 말고 현재 국적 국가의 국적법과 신고·상실 규칙을 해당 정부기관 또는 전문가에게 별도로 확인하세요.",
    sourceIds: ["citizenship-source-conferral"],
  },
] as const;
